'use client';
import { addDays, startOfDay } from 'date-fns';
import React, { useState } from 'react';
import DateSelectAlternate from '../../SearchForm/children/DateSelectAlternate';
export const DateDurationSelector = ({ onSelect, nights, value, seasons = [], singleColumn, inventoryDataUrl = '', isLeadingPricesEnabled = false, inventoryDataQueryParams, }) => {
    const [selectedDurations, setSelectedDurations] = useState([nights.toString()]);
    return (<DateSelectAlternate setToDefaultOnNightChange onChange={onSelect} preSelectedNights={nights ? +nights : 7} value={{
            date: [new Date(value), startOfDay(addDays(new Date(value), nights[0]))],
            nights: nights,
        }} seasons={seasons} singleColumn={singleColumn} inventoryDataUrl={inventoryDataUrl} isLeadingPricesEnabled={isLeadingPricesEnabled} inventoryDataQueryParams={inventoryDataQueryParams} selectedDurations={selectedDurations} setSelectedDurations={setSelectedDurations}/>);
};
